export default class AdminSearch {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  autocomplete(search_type, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminSearchEndpoint}/${search_type}/autocomplete`, {
      params
    })
  }
}
